<template>
  <div class="auth-modal" v-if="show">
    <div class="auth-overlay" @click="$emit('close')"></div>
    <div class="auth-container">
      <div class="tab-group">
        <div class="tab" :class="{ active: activeTab === 'login' }" @click="activeTab = 'login'">登录</div>
        <div class="tab" :class="{ active: activeTab === 'register' }" @click="activeTab = 'register'">注册</div>
      </div>

      <!-- 登录表单 -->
      <form id="loginForm" class="form-content" v-show="activeTab === 'login'" @submit.prevent="handleLoginCaptcha">
        <div class="form-group">
          <input type="text" v-model="loginForm.username" name="username" placeholder="用户名" required
                 @blur="validateLoginField('username')">
          <div class="error-message" v-if="loginErrors.username" v-text="loginErrors.username" style="display: block;"></div>
        </div>
        <div class="form-group">
          <input type="password" v-model="loginForm.password" name="password" placeholder="密码" required
                 @blur="validateLoginField('password')">
          <div class="error-message" v-if="loginErrors.password" v-text="loginErrors.password" style="display: block;"></div>
        </div>
        <div class="form-group captcha-form-group">
          <div id="login-captcha-container" class="captcha-container">
            <div v-if="captchaLoading" class="captcha-loading">验证码加载中...</div>
          </div>
          <div class="error-message" v-if="loginErrors.captcha" v-text="loginErrors.captcha" style="display: block;"></div>
          <div class="error-message" v-if="captchaLoadError" style="display: block;">验证码加载失败，请刷新页面重试</div>
        </div>
        <button type="submit" :disabled="loading || captchaLoading || hasLoginErrors">
          <span v-if="loading" class="spinner"></span>
          立即登录
        </button>
        <div class="success-message" v-if="loginSuccess" style="display: block;">登录成功！</div>
        <div class="retry-captcha" v-if="captchaLoadError">
          <a href="#" @click.prevent="reloadCaptcha">重新加载验证码</a>
        </div>
      </form>

      <!-- 注册表单 -->
      <form id="registerForm" class="form-content" v-show="activeTab === 'register'" @submit.prevent="handleRegisterCaptcha">
        <div class="form-group">
          <input type="text" v-model="registerForm.username" name="username" placeholder="用户名 (2-10位，可以中文)" required
                 @blur="validateRegisterField('username')">
          <div class="error-message" v-if="registerErrors.username" v-text="registerErrors.username" style="display: block;"></div>
        </div>
        <div class="form-group">
          <input type="password" v-model="registerForm.password" name="password" placeholder="密码 (6-32位)" required
                 @blur="validateRegisterField('password')">
          <div class="error-message" v-if="registerErrors.password" v-text="registerErrors.password" style="display: block;"></div>
        </div>
        <div class="form-group">
          <input type="tel" v-model="registerForm.phone" name="phone" placeholder="手机号" required
                 @blur="validateRegisterField('phone')" @input="formatPhoneNumber">
          <div class="error-message" v-if="registerErrors.phone" v-text="registerErrors.phone" style="display: block;"></div>
        </div>
        <div class="form-group">
          <label for="register-invite-code">邀请码 <small class="text-muted">(选填)</small></label>
          <input
            type="text"
            id="register-invite-code"
            v-model="registerForm.inviteCode"
            placeholder="使用邀请码获得额外福利"
            maxlength="12"
          />
            <!-- <small class="form-text text-muted">
              <i class="fas fa-info-circle"></i> 
              填写邀请码可获得额外福利
            </small> -->
        </div>
        <div class="form-group captcha-form-group">
          <div id="register-captcha-container" class="captcha-container">
            <div v-if="captchaLoading" class="captcha-loading">验证码加载中...</div>
          </div>
          <div class="error-message" v-if="registerErrors.captcha" v-text="registerErrors.captcha" style="display: block;"></div>
          <div class="error-message" v-if="captchaLoadError" style="display: block;">验证码加载失败，请刷新页面重试</div>
        </div>
        <button type="submit" :disabled="loading || captchaLoading || hasRegisterErrors">
          <span v-if="loading" class="spinner"></span>
          立即注册
        </button>
        <div class="success-message" v-if="registerSuccess" style="display: block;">注册成功！</div>
        <div class="retry-captcha" v-if="captchaLoadError">
          <a href="#" @click.prevent="reloadCaptcha">重新加载验证码</a>
        </div>
      </form>
    </div>
    
    <!-- 错误提示模态框 -->
    <div class="error-modal" v-if="errorModalVisible">
      <div class="error-modal-overlay" @click="closeErrorModal"></div>
      <div class="error-modal-container">
        <div class="error-modal-header">
          <h4>{{ errorModalTitle }}</h4>
          <button class="error-modal-close" @click="closeErrorModal">×</button>
        </div>
        <div class="error-modal-content">
          <div class="error-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
          </div>
          <p v-if="!errorModalAllowHTML">{{ errorModalMessage }}</p>
          <p v-else v-html="errorModalMessage"></p>
        </div>
        <div class="error-modal-footer">
          <button class="btn error-modal-btn" @click="closeErrorModal">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { CAPTCHA_APP_ID } from '../config/captcha';

export default {
  name: 'AuthModal',
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      activeTab: 'login',
      loading: false,
      captchaLoading: true,
      captchaLoadError: false,
      captchaLoadRetries: 0,
      captchaAutoRetryCount: 0,
      captchaMaxAutoRetries: 2,
      
      // 错误模态框
      errorModalVisible: false,
      errorModalTitle: '错误提示',
      errorModalMessage: '',
      
      // 浏览器兼容性信息
      browserInfo: {
        isIOS: false,
        isAndroid: false,
        browserName: '',
        isInWeChat: false,
        hasVPN: false
      },
      
      // 登录表单数据
      loginForm: {
        username: '',
        password: '',
        captchaTicket: '',
        captchaRandstr: ''
      },
      loginErrors: {},
      loginSuccess: false,
      
      // 注册表单数据
      registerForm: {
        username: '',
        password: '',
        phone: '',
        inviteCode: '',
        captchaTicket: '',
        captchaRandstr: ''
      },
      registerErrors: {},
      registerSuccess: false,
      
      // 验证码对象
      loginCaptcha: null,
      registerCaptcha: null,
      errorModalAllowHTML: false
    };
  },
  computed: {
    // 检查登录表单是否有错误
    hasLoginErrors() {
      return Object.keys(this.loginErrors).length > 0;
    },
    
    // 检查注册表单是否有错误
    hasRegisterErrors() {
      return Object.keys(this.registerErrors).length > 0;
    }
  },
  watch: {
    show(newVal) {
      if (newVal && !this.loginCaptcha && !this.registerCaptcha) {
        // 在组件显示时，初始化验证码
        this.$nextTick(() => {
          this.loadCaptchaScript();
        });
      }
    },
    activeTab(newVal) {
      if (newVal === 'login' && !this.loginCaptcha) {
        this.$nextTick(() => {
          this.initLoginCaptcha();
        });
      } else if (newVal === 'register' && !this.registerCaptcha) {
        this.$nextTick(() => {
          this.initRegisterCaptcha();
        });
      }
    }
  },
  mounted() {
    if (this.show) {
      this.loadCaptchaScript();
      this.detectBrowserEnvironment();
    }
  },
  methods: {
    // 检测浏览器环境
    detectBrowserEnvironment() {
      const ua = navigator.userAgent.toLowerCase();
      const browserInfo = this.browserInfo;
      
      // 检测操作系统
      browserInfo.isIOS = /iphone|ipad|ipod/.test(ua);
      browserInfo.isAndroid = /android/.test(ua);
      
      // 检测浏览器
      if (/micromessenger/.test(ua)) {
        browserInfo.browserName = '微信浏览器';
        browserInfo.isInWeChat = true;
      } else if (/qq/.test(ua) && !/qqbrowser/.test(ua)) {
        browserInfo.browserName = 'QQ内置浏览器';
      } else if (/ucbrowser/.test(ua)) {
        browserInfo.browserName = 'UC浏览器';
      } else if (/quark/.test(ua)) {
        browserInfo.browserName = '夸克浏览器';
      } else if (/firefox/.test(ua)) {
        browserInfo.browserName = 'Firefox';
      } else if (/edg/.test(ua)) {
        browserInfo.browserName = 'Edge';
      } else if (/chrome/.test(ua)) {
        browserInfo.browserName = 'Chrome';
      } else if (/safari/.test(ua)) {
        browserInfo.browserName = 'Safari';
      } else {
        browserInfo.browserName = '未知浏览器';
      }
      
      // 尝试检测可能的VPN使用（这只是一个简单的估计，不是100%准确）
      this.checkPossibleVPN();
      
      console.log('浏览器环境:', browserInfo);
    },
    
    // 检测可能的VPN使用
    checkPossibleVPN() {
      // 检查时区与系统设置时区的差异（可能表明VPN使用）
      const now = new Date();
      const timeZoneOffset = now.getTimezoneOffset();
      
      // 中国时区通常是 UTC+8，即 -480 分钟
      // 如果偏差较大可能使用了VPN（这只是一个估计）
      if (Math.abs(timeZoneOffset + 480) > 60) {
        this.browserInfo.hasVPN = true;
      }
      
      // 检查WebRTC泄漏（需要更复杂的实现）
      // 这里只是一个占位，实际实现需要更多代码
    },
    
    loadCaptchaScript() {
      this.captchaLoading = true;
      this.captchaLoadError = false;
      
      // 检查是否已经加载过脚本
      if (window.TencentCaptcha) {
        this.initCaptcha();
        return;
      }
      
      // 检查是否已经在加载脚本
      if (document.getElementById('tencent-captcha-script')) {
        // 脚本正在加载，等待加载完成
        const existingScript = document.getElementById('tencent-captcha-script');
        existingScript.addEventListener('load', () => {
          setTimeout(() => this.initCaptcha(), 100);
        });
        return;
      }
      
      console.log(`尝试加载验证码 (第${this.captchaAutoRetryCount + 1}次)`);
      
      // 设置脚本加载超时计时器
      const loadTimeout = setTimeout(() => {
        if (this.captchaLoading && !window.TencentCaptcha) {
          console.error('Tencent Captcha script load timeout');
          
          // 检查是否可以自动重试
          if (this.captchaAutoRetryCount < this.captchaMaxAutoRetries) {
            this.captchaAutoRetryCount++;
            console.log(`验证码加载超时，自动重试(${this.captchaAutoRetryCount}/${this.captchaMaxAutoRetries})`);
            this.autoRetryCaptcha();
          } else {
            this.captchaLoadError = true;
            this.captchaLoading = false;
            this.showCaptchaCompatibilityAlert();
          }
        }
      }, 8000); // 8秒超时
      
      // 动态加载验证码JS
      const script = document.createElement('script');
      script.setAttribute('id', 'tencent-captcha-script');
      script.setAttribute('src', 'https://turing.captcha.qcloud.com/TCaptcha.js');
      
      // 添加加载和错误事件处理
      script.onload = () => {
        clearTimeout(loadTimeout);
        console.log('Tencent Captcha script loaded successfully');
        this.captchaAutoRetryCount = 0; // 重置自动重试计数
        
        // 确保TencentCaptcha已经定义
        setTimeout(() => {
          if (window.TencentCaptcha) {
            this.initCaptcha();
          } else {
            console.error('TencentCaptcha is not defined after script load');
            
            // 检查是否可以自动重试
            if (this.captchaAutoRetryCount < this.captchaMaxAutoRetries) {
              this.captchaAutoRetryCount++;
              console.log(`验证码对象未定义，自动重试(${this.captchaAutoRetryCount}/${this.captchaMaxAutoRetries})`);
              this.autoRetryCaptcha();
            } else {
              this.captchaLoadError = true;
              this.captchaLoading = false;
              this.showCaptchaCompatibilityAlert();
            }
          }
        }, 300);
      };
      
      script.onerror = (error) => {
        clearTimeout(loadTimeout);
        console.error('Failed to load Tencent Captcha script', error);
        
        // 检查是否可以自动重试
        if (this.captchaAutoRetryCount < this.captchaMaxAutoRetries) {
          this.captchaAutoRetryCount++;
          console.log(`验证码加载失败，自动重试(${this.captchaAutoRetryCount}/${this.captchaMaxAutoRetries})`);
          this.autoRetryCaptcha();
        } else {
          this.captchaLoadError = true;
          this.captchaLoading = false;
          this.showCaptchaCompatibilityAlert();
        }
      };
      
      document.head.appendChild(script);
    },
    
    // 自动重试加载验证码
    autoRetryCaptcha() {
      // 移除旧脚本
      const oldScript = document.getElementById('tencent-captcha-script');
      if (oldScript) {
        oldScript.remove();
      }
      
      // 随机延迟 1-3 秒后重试，避免同时请求
      const retryDelay = 1000 + Math.floor(Math.random() * 2000);
      console.log(`将在 ${retryDelay}ms 后重试加载验证码...`);
      
      setTimeout(() => {
        // 尝试使用备用CDN
        this.loadCaptchaScriptWithAlternativeCDN();
      }, retryDelay);
    },
    
    // 尝试使用备用CDN加载验证码
    loadCaptchaScriptWithAlternativeCDN() {
      this.captchaLoading = true;
      this.captchaLoadError = false;
      
      // 根据重试次数选择不同的CDN源
      const cdnUrls = [
        'https://turing.captcha.qcloud.com/TCaptcha.js',
        'https://cdn.jsdelivr.net/gh/TencentCloud/captcha-web-sdk@latest/TCaptcha.min.js',
        'https://ssl.captcha.qq.com/TCaptcha.js'
      ];
      
      // 选择CDN源（循环使用）
      const cdnIndex = this.captchaAutoRetryCount % cdnUrls.length;
      const scriptUrl = cdnUrls[cdnIndex];
      
      console.log(`尝试使用备用源加载验证码: ${scriptUrl}`);
      
      // 设置脚本加载超时计时器
      const loadTimeout = setTimeout(() => {
        if (this.captchaLoading && !window.TencentCaptcha) {
          console.error('Tencent Captcha script load timeout (alternative CDN)');
          this.captchaLoadError = true;
          this.captchaLoading = false;
          this.showCaptchaCompatibilityAlert();
        }
      }, 8000); // 8秒超时
      
      // 动态加载验证码JS
      const script = document.createElement('script');
      script.setAttribute('id', 'tencent-captcha-script');
      script.setAttribute('src', scriptUrl);
      
      // 添加加载和错误事件处理
      script.onload = () => {
        clearTimeout(loadTimeout);
        console.log('Tencent Captcha script loaded successfully (alternative CDN)');
        
        // 确保TencentCaptcha已经定义
        setTimeout(() => {
          if (window.TencentCaptcha) {
            this.initCaptcha();
          } else {
            console.error('TencentCaptcha is not defined after script load (alternative CDN)');
            this.captchaLoadError = true;
            this.captchaLoading = false;
            this.showCaptchaCompatibilityAlert();
          }
        }, 300);
      };
      
      script.onerror = (error) => {
        clearTimeout(loadTimeout);
        console.error('Failed to load Tencent Captcha script (alternative CDN)', error);
        this.captchaLoadError = true;
        this.captchaLoading = false;
        this.showCaptchaCompatibilityAlert();
      };
      
      document.head.appendChild(script);
    },
    
    reloadCaptcha() {
      // 确保不会无限重试
      if (this.captchaLoadRetries >= 3) {
        this.showErrorModal('验证码加载失败', '验证码加载多次失败，请检查网络连接或稍后再试');
        return;
      }
      
      this.captchaLoadRetries++;
      this.captchaAutoRetryCount = 0; // 重置自动重试计数
      this.captchaLoadError = false;
      this.captchaLoading = true;
      
      // 移除旧脚本
      const oldScript = document.getElementById('tencent-captcha-script');
      if (oldScript) {
        oldScript.remove();
      }
      
      // 重置验证码对象
      this.loginCaptcha = null;
      this.registerCaptcha = null;
      
      // 重新加载脚本
      this.loadCaptchaScript();
    },
    
    initCaptcha() {
      // 确保页面已加载TencentCaptcha
      if (typeof window.TencentCaptcha === 'undefined') {
        console.error('TencentCaptcha not loaded yet');
        if (this.captchaLoadRetries < 3) {
          setTimeout(() => this.initCaptcha(), 500);
        } else {
          this.captchaLoadError = true;
          this.captchaLoading = false;
        }
        return;
      }
      
      this.initLoginCaptcha();
      this.initRegisterCaptcha();
      this.captchaLoading = false;
    },
    
    initLoginCaptcha() {
      try {
        // 确保TencentCaptcha已定义
        if (typeof window.TencentCaptcha === 'function') {
          this.loginCaptcha = new window.TencentCaptcha(CAPTCHA_APP_ID, (res) => {
            if (res.ret === 0) {
              // 验证成功
              this.loginForm.captchaTicket = res.ticket;
              this.loginForm.captchaRandstr = res.randstr;
              this.handleLogin();
            } else {
              // 用户主动关闭验证码
              console.log('用户关闭验证码');
              this.loading = false;
              
              // 根据错误码提供更有用的提示
              if (res.ret === 2) {
                this.loginErrors.captcha = '您取消了验证，请重新验证';
              } else if (res.ret === 1) {
                this.loginErrors.captcha = '验证失败，请重新尝试';
              }
              
              // 清除验证码错误，以便用户可以再次点击按钮
              setTimeout(() => {
                if (this.loginErrors.captcha) {
                  delete this.loginErrors.captcha;
                }
              }, 3000);
            }
          }, {
            ready: () => {
              // 验证码准备完成的回调
              console.log('登录验证码准备完成');
            },
            needFeedBack: true, // 允许用户反馈
            enableClose: true // 允许用户关闭
          });
        } else {
          console.error('TencentCaptcha is not defined when initializing login captcha');
          this.loginErrors.captcha = '验证码组件加载失败，请刷新页面重试';
          this.captchaLoadError = true;
        }
      } catch (error) {
        console.error('初始化登录验证码失败', error);
        this.loginErrors.captcha = '验证码初始化失败，请刷新页面重试';
        this.captchaLoadError = true;
      }
    },
    
    initRegisterCaptcha() {
      try {
        // 确保TencentCaptcha已定义
        if (typeof window.TencentCaptcha === 'function') {
          this.registerCaptcha = new window.TencentCaptcha(CAPTCHA_APP_ID, (res) => {
            if (res.ret === 0) {
              // 验证成功
              this.registerForm.captchaTicket = res.ticket;
              this.registerForm.captchaRandstr = res.randstr;
              this.handleRegister();
            } else {
              // 用户主动关闭验证码
              console.log('用户关闭验证码');
              this.loading = false;
              
              // 根据错误码提供更有用的提示
              if (res.ret === 2) {
                this.registerErrors.captcha = '您取消了验证，请重新验证';
              } else if (res.ret === 1) {
                this.registerErrors.captcha = '验证失败，请重新尝试';
              }
              
              // 清除验证码错误，以便用户可以再次点击按钮
              setTimeout(() => {
                if (this.registerErrors.captcha) {
                  delete this.registerErrors.captcha;
                }
              }, 3000);
            }
          }, {
            ready: () => {
              // 验证码准备完成的回调
              console.log('注册验证码准备完成');
            },
            needFeedBack: true, // 允许用户反馈
            enableClose: true // 允许用户关闭
          });
        } else {
          console.error('TencentCaptcha is not defined when initializing register captcha');
          this.registerErrors.captcha = '验证码组件加载失败，请刷新页面重试';
          this.captchaLoadError = true;
        }
      } catch (error) {
        console.error('初始化注册验证码失败', error);
        this.registerErrors.captcha = '验证码初始化失败，请刷新页面重试';
        this.captchaLoadError = true;
      }
    },
    handleLoginCaptcha() {
      this.loginErrors = {};
      
      // 验证表单所有字段
      this.validateLoginField('username');
      this.validateLoginField('password');
      
      // 如果有验证错误，不继续处理
      if (this.hasLoginErrors) {
        return;
      }
      
      // 显示验证码
      if (this.loginCaptcha) {
        this.loginCaptcha.show();
      } else {
        console.error('验证码未初始化');
        this.loginErrors.captcha = '验证码加载失败';
      }
    },
    handleRegisterCaptcha() {
      this.registerErrors = {};
      
      // 验证表单所有字段
      this.validateRegisterField('username');
      this.validateRegisterField('password');
      this.validateRegisterField('phone');
      
      // 如果有验证错误，不继续处理
      if (this.hasRegisterErrors) {
        return;
      }
      
      // 显示验证码
      if (this.registerCaptcha) {
        this.registerCaptcha.show();
      } else {
        console.error('验证码未初始化');
        this.registerErrors.captcha = '验证码加载失败';
      }
    },
    handleLogin() {
      this.loading = true;
      this.loginErrors = {};
      this.loginSuccess = false;
      
      axios.post('/auth/login', this.loginForm)
        .then(response => {
          this.loading = false;
          
          if (response.data.success) {
            // 登录成功
            this.loginSuccess = true;
            
            // 存储token
            if (response.data.token) {
              localStorage.setItem('user', JSON.stringify(response.data));
            }
            
            // 通知父组件登录成功
            this.$emit('login-success');
            
            // 1秒后关闭模态窗口并刷新页面
            setTimeout(() => {
              this.$emit('close');
              window.location.reload();
            }, 1000);
          } else {
            // 登录未成功但请求成功的情况
            if(response.data.errors){
              // 从错误对象中提取第一个错误信息显示在模态框中
              const firstErrorField = Object.keys(response.data.errors)[0];
              if (firstErrorField) {
                let errorMsg = response.data.errors[firstErrorField];
                
                // 如果错误消息是数组，取第一个元素并清理格式
                if (Array.isArray(errorMsg)) {
                  errorMsg = errorMsg[0];
                }
                
                // 清理错误消息中可能存在的["和"]字符
                if (typeof errorMsg === 'string') {
                  errorMsg = errorMsg.replace(/\["|\"\]/g, '').replace(/\\"/g, '"');
                }
                
                this.showErrorModal('登录失败', errorMsg);
              }
            }
            else if (response.data.message) {
              this.showErrorModal('登录失败', response.data.message);
            }
            // 通知父组件登录失败，重置交互标志
            this.$emit('login-failed');
          }
        })
        .catch(error => {
          this.loading = false;
          
          if (error.response && error.response.data) {
            const { data } = error.response;
            
            if (data.errors) {
              this.loginErrors = data.errors;
              
              // 从错误对象中提取第一个错误信息显示在模态框中
              const firstErrorField = Object.keys(data.errors)[0];
              if (firstErrorField) {
                this.showErrorModal('登录失败', data.errors[firstErrorField]);
              }
            } else {
              // 显示一般错误消息
              this.showErrorModal('登录失败', data.message || '登录失败，请稍后重试');
            }
          } else {
            this.showErrorModal('登录失败', '发生错误，请稍后再试');
          }
          
          // 通知父组件登录失败，重置交互标志
          this.$emit('login-failed');
        });
    },
    
    handleRegister() {
      this.loading = true;
      this.registerErrors = {};
      this.registerSuccess = false;
      
      // 创建一个新对象来存储发送给后端的数据
      const registerData = {
        ...this.registerForm,
        // 确保手机号没有空格或其他格式字符
        phone: this.registerForm.phone.replace(/\s/g, ''),
        invite_code: this.registerForm.inviteCode || null,
      };
      
      axios.post('/auth/register', registerData)
        .then(response => {
          this.loading = false;
          
          if (response.data.success) {
            // 注册成功
            this.registerSuccess = true;
            
            // 存储token
            if (response.data.token) {
              localStorage.setItem('user', JSON.stringify(response.data));
            }
            
            // 通知父组件登录成功
            this.$emit('login-success');
            
            // 1秒后关闭模态窗口并刷新页面
            setTimeout(() => {
              this.$emit('close');
              window.location.reload();
            }, 1000);
          } else {
            // 注册未成功但请求成功的情况
            if(response.data.errors){
              // 从错误对象中提取第一个错误信息显示在模态框中
              const firstErrorField = Object.keys(response.data.errors)[0];
              if (firstErrorField) {
                let errorMsg = response.data.errors[firstErrorField];
                
                // 如果错误消息是数组，取第一个元素并清理格式
                if (Array.isArray(errorMsg)) {
                  errorMsg = errorMsg[0];
                }
                
                // 清理错误消息中可能存在的["和"]字符
                if (typeof errorMsg === 'string') {
                  errorMsg = errorMsg.replace(/\["|\"\]/g, '').replace(/\\"/g, '"');
                }
                
                this.showErrorModal('注册失败', errorMsg);
              }
            }
            else if (response.data.message) {
              this.showErrorModal('注册失败', response.data.message);
            }
            // 通知父组件登录失败，重置交互标志
            this.$emit('login-failed');
          }
        })
        .catch(error => {
          this.loading = false;
          
          if (error.response && error.response.data) {
            const { data } = error.response;
            
            if (data.errors) {
              this.registerErrors = data.errors;
              
              // 从错误对象中提取第一个错误信息显示在模态框中
              const firstErrorField = Object.keys(data.errors)[0];
              if (firstErrorField) {
                let errorMsg = data.errors[firstErrorField];
                
                // 如果错误消息是数组，取第一个元素并清理格式
                if (Array.isArray(errorMsg)) {
                  errorMsg = errorMsg[0];
                }
                
                // 清理错误消息中可能存在的["和"]字符
                if (typeof errorMsg === 'string') {
                  errorMsg = errorMsg.replace(/\["|\"\]/g, '').replace(/\\"/g, '"');
                }
                
                this.showErrorModal('注册失败', errorMsg);
              }
            } else {
              // 显示一般错误消息
              this.showErrorModal('注册失败', data.message || '注册失败，请稍后重试');
            }
          } else {
            this.showErrorModal('注册失败', '发生错误，请稍后再试');
          }
          
          // 通知父组件登录失败，重置交互标志
          this.$emit('login-failed');
        });
    },
    
    // 登录字段验证
    validateLoginField(field) {
      const value = this.loginForm[field];
      
      switch (field) {
        case 'username':
          if (!value || value.trim() === '') {
            this.loginErrors.username = '请输入用户名';
          } else if (value.length < 2 || value.length > 10) {
            this.loginErrors.username = '用户名长度必须在2-10个字符之间';
          } else {
            delete this.loginErrors.username;
          }
          break;
          
        case 'password':
          if (!value || value.trim() === '') {
            this.loginErrors.password = '请输入密码';
          } else if (value.length < 6 || value.length > 32) {
            this.loginErrors.password = '密码长度必须在6-32个字符之间';
          } else {
            delete this.loginErrors.password;
          }
          break;
      }
    },
    
    // 注册字段验证
    validateRegisterField(field) {
      const value = this.registerForm[field];
      
      switch (field) {
        case 'username':
          if (!value || value.trim() === '') {
            this.registerErrors.username = '请输入用户名';
          } else if (value.length < 2 || value.length > 10) {
            this.registerErrors.username = '用户名长度必须在2-10个字符之间';
          } else {
            delete this.registerErrors.username;
          }
          break;
          
        case 'password':
          if (!value || value.trim() === '') {
            this.registerErrors.password = '请输入密码';
          } else if (value.length < 6) {
            this.registerErrors.password = '密码长度不能少于6个字符';
          } else if (value.length > 32) {
            this.registerErrors.password = '密码长度不能超过32个字符';
          } else {
            delete this.registerErrors.password;
          }
          break;
          
        case 'phone':
          if (!value || value.trim() === '') {
            this.registerErrors.phone = '请输入手机号';
          } else {
            // 移除格式化字符，只检查纯数字部分
            const phoneDigitsOnly = value.replace(/\s/g, '');
            if (!/^1[3-9]\d{9}$/.test(phoneDigitsOnly)) {
              this.registerErrors.phone = '请输入正确的手机号码格式';
            } else {
              delete this.registerErrors.phone;
            }
          }
          break;
      }
    },
    
    // 格式化手机号输入 (例如：188 8888 8888)
    formatPhoneNumber() {
      // 保存原始输入值，移除所有非数字字符
      let phone = this.registerForm.phone.replace(/\D/g, '');
      
      // 限制最大长度为11位
      if (phone.length > 11) {
        phone = phone.substring(0, 11);
      }
      
      // 格式化为 "188 8888 8888" 格式 (仅用于显示)
      let formattedPhone = '';
      if (phone.length > 0) {
        formattedPhone = phone.substring(0, Math.min(3, phone.length));
        if (phone.length > 3) {
          formattedPhone += ' ' + phone.substring(3, Math.min(7, phone.length));
          if (phone.length > 7) {
            formattedPhone += ' ' + phone.substring(7, Math.min(11, phone.length));
          }
        }
      }
      
      this.registerForm.phone = formattedPhone;
    },
    
    // 显示验证码兼容性提示
    showCaptchaCompatibilityAlert() {
      let message = '验证码加载失败，可能是由于以下原因：';
      let suggestions = [];
      
      const { isIOS, isAndroid, browserName, isInWeChat, hasVPN } = this.browserInfo;
      
      // 根据浏览器环境添加具体建议
      if (isInWeChat) {
        suggestions.push('微信内置浏览器可能无法正常加载验证码，请点击右上角选择"在浏览器中打开"');
      }
      
      if (hasVPN) {
        suggestions.push('检测到可能使用了VPN或代理，请关闭后重试');
      }
      
      if (isIOS) {
        suggestions.push('iOS设备推荐使用Safari浏览器');
      } else if (isAndroid) {
        suggestions.push('Android设备推荐使用Chrome或系统自带浏览器');
      }
      
      // 添加网络相关建议
      suggestions.push('当前网络环境可能不稳定，已尝试自动重试加载但仍失败');
      suggestions.push('尝试使用4G/5G网络而非WiFi');
      suggestions.push('尝试使用其他主流浏览器（Chrome、Safari、Edge）');
      suggestions.push('刷新页面后重试');
      
      // 组合消息
      if (suggestions.length > 0) {
        message += '<ul class="suggestion-list">';
        suggestions.forEach(suggestion => {
          message += `<li>${suggestion}</li>`;
        });
        message += '</ul>';
      }
      
      this.showErrorModal('验证码加载失败', message, true);
    },
    
    // 显示错误模态框（添加了HTML支持选项）
    showErrorModal(title, message, allowHTML = false) {
      this.errorModalTitle = title || '错误提示';
      this.errorModalMessage = message || '操作失败，请稍后重试';
      this.errorModalVisible = true;
      this.errorModalAllowHTML = allowHTML;
    },
    
    // 关闭错误模态框
    closeErrorModal() {
      this.errorModalVisible = false;
    }
  }
};
</script>

<style scoped>
.auth-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.auth-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(3px);
}

.auth-container {
  background: white;
  width: 100%;
  max-width: 400px;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
  padding: 40px;
  z-index: 1;
  position: relative;
}

/* 暗黑模式下的auth-container样式 */
[data-theme="dark"] .auth-container {
  background: #1e1e1e;
  box-shadow: 0 10px 30px rgba(0,0,0,0.3);
}

[data-theme="dark"] .tab {
  color: #a1a1aa;
}

[data-theme="dark"] .tab.active {
  color: #a5b4fc;
}

[data-theme="dark"] .tab.active::after {
  background: #6366f1;
}

[data-theme="dark"] label,
[data-theme="dark"] .form-text {
  color: #d1d5db;
}

[data-theme="dark"] .text-muted {
  color: #9ca3af !important;
}

.tab-group {
  display: flex;
  gap: 20px;
  margin-bottom: 30px;
}

.tab {
  cursor: pointer;
  font-weight: 600;
  color: #6b7280;
  padding: 8px 0;
  transition: all 0.3s ease;
  position: relative;
}

.tab.active {
  color: #6366f1;
}

.tab.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: #6366f1;
}

.form-group {
  margin-bottom: 20px;
}

.captcha-form-group {
  margin-bottom: 10px;
  margin-top: -5px;
}

input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 16px;
  transition: all 0.3s ease;
  background-color: #fff;
  color: #333;
}

input:focus {
  outline: none;
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

button {
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  border: none;
  border-radius: 8px;
  color: white;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease;
  position: relative;
}

button:hover {
  transform: translateY(-2px);
}

button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

.error-message {
  color: #ef4444;
  font-size: 14px;
  margin-top: 5px;
  display: none;
}

.success-message {
  color: #10b981;
  font-size: 14px;
  margin-top: 15px;
  text-align: center;
  display: none;
}

.spinner {
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 1s linear infinite;
  margin-right: 8px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

@media (max-width: 480px) {
  .auth-container {
    max-width: 94%;
    padding: 25px 20px;
    margin: 0 10px;
    border-radius: 12px;
  }
  
  .tab-group {
    margin-bottom: 20px;
  }
  
  input {
    font-size: 16px; /* 避免iOS缩放 */
    padding: 10px 14px;
  }
  
  button {
    padding: 12px 14px;
  }
  
  .form-group {
    margin-bottom: 16px;
  }
}

/* 竖屏小屏幕设备特别优化 */
@media (max-width: 380px) and (orientation: portrait) {
  .auth-container {
    padding: 20px 15px;
  }
  
  .tab {
    font-size: 14px;
  }
  
  .tab-group {
    gap: 12px;
    margin-bottom: 16px;
  }
}

.captcha-container {
  width: 100%;
  min-height: 10px;
  margin: 0;
  position: relative;
}

.captcha-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  background-color: #f9fafb;
  border-radius: 8px;
  color: #6366f1;
  font-size: 14px;
}

/* 添加暗黑模式下的验证码容器样式 */
[data-theme="dark"] .captcha-loading {
  background-color: #374151;
  color: #a5b4fc;
}

.captcha-tips {
  color: #6b7280;
  font-size: 12px;
  margin-top: 5px;
}

.retry-captcha {
  text-align: center;
  margin-top: 10px;
}

.retry-captcha a {
  color: #6366f1;
  text-decoration: none;
  font-size: 14px;
}

.retry-captcha a:hover {
  text-decoration: underline;
}

/* 错误模态框样式 */
.error-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000; /* 确保比主模态框层级高 */
}

.error-modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
}

.error-modal-container {
  background: white;
  width: 100%;
  max-width: 360px;
  border-radius: 12px;
  box-shadow: 0 15px 30px rgba(0,0,0,0.2);
  z-index: 1;
  position: relative;
  overflow: hidden;
  animation: errorModalAppear 0.3s ease;
  max-height: 80vh;
  overflow-y: auto;
}

@keyframes errorModalAppear {
  from { transform: scale(0.9); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

.error-modal-header {
  padding: 12px 16px;
  border-bottom: 1px solid #f1f1f1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(to right, #ff6b6b, #ef4444);
  color: white;
  min-height: 48px;
}

.error-modal-header h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: white;
  text-shadow: 0 1px 2px rgba(0,0,0,0.1);
  letter-spacing: 0.5px;
  line-height: 1.3;
  padding-right: 10px;
  width: calc(100% - 30px); /* 给关闭按钮留出空间 */
}

.error-modal-close {
  background: none;
  border: none;
  font-size: 24px;
  color: white;
  cursor: pointer;
  padding: 0;
  margin: 0;
  line-height: 1;
  opacity: 0.8;
  transition: opacity 0.2s ease;
}

.error-modal-close:hover {
  opacity: 1;
}

.error-modal-content {
  padding: 16px;
  display: flex;
  align-items: flex-start;
}

.error-icon {
  width: 20px;
  height: 20px;
  margin-right: 12px;
  color: #ef4444;
  flex-shrink: 0;
}

.error-icon svg {
  width: 100%;
  height: 100%;
}

.error-modal-content p {
  margin: 0;
  font-size: 14px;
  color: #374151;
  line-height: 1.5;
  flex: 1;
  word-break: break-word;
}

.error-modal-footer {
  padding: 12px 16px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #f1f1f1;
  background-color: #f9fafb;
}

.error-modal-btn {
  padding: 8px 18px;
  background: linear-gradient(135deg, #ff6b6b, #ef4444);
  border: none;
  border-radius: 6px;
  color: white;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
}

.error-modal-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
}

.error-modal-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(239, 68, 68, 0.3);
}

@media (max-width: 480px) {
  .error-modal-container {
    max-width: 90%;
    max-height: 70vh; /* 减小移动端显示高度 */
  }
  
  .error-modal-header h4 {
    font-size: 14px;
    padding-right: 5px; /* 防止与关闭按钮重叠 */
  }
  
  .error-modal-content p {
    font-size: 13px;
  }
  
  .error-icon {
    width: 18px;
    height: 18px;
    margin-right: 10px;
  }
  
  .error-modal-footer {
    padding: 10px 12px;
  }
  
  .error-modal-btn {
    padding: 8px 16px;
    width: auto; /* 防止按钮占满整个容器宽度 */
    min-width: 80px;
  }
}

/* 针对较小屏幕或横屏模式的优化 */
@media (max-height: 600px), (max-width: 380px) {
  .error-modal-container {
    max-height: 85vh;
  }
  
  .error-modal-header {
    padding: 10px 12px;
  }
  
  .error-modal-content {
    padding: 12px;
  }
}

.suggestion-list {
  margin: 8px 0 0 0;
  padding-left: 16px;
  text-align: left;
}

.suggestion-list li {
  margin-bottom: 5px;
  line-height: 1.4;
  font-size: 13px;
}

.suggestion-list li:last-child {
  margin-bottom: 0;
}

/* 添加黑夜模式下的白色输入框样式 */
[data-theme="dark"] input {
  background-color: #fff;
  color: #333;
  border-color: #4b5563;
}

[data-theme="dark"] input:focus {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);
}
</style> 